
<template>
  <div class="publish-container">
    <div class="publish-header">
      <h1 class="publish-title">创作文章</h1>
      <p class="publish-subtitle">分享你的知识和见解</p>
    </div>
    
    <div class="publish-content">
      <div class="publish-main">
        <div class="form-section">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">
                <i class="el-icon-folder"></i>
                <span>选择分类</span>
              </label>
              <el-cascader
                v-model="selectCommunity"
                :options="communityList"
                :props="{ expandTrigger: 'hover', value: 'value', label: 'label', children: 'children' }"
                placeholder="请选择文章分类"
                clearable
                @change="handleChange"
                class="category-cascader">
              </el-cascader>
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="el-icon-edit-outline"></i>
                <span>文章标题</span>
              </label>
              <div class="title-input-wrapper">
                <input 
                  type="text" 
                  class="post-title-input"
                  v-model="title" 
                  placeholder="请输入文章标题..."
                  maxlength="100"
                />
                <span class="char-count" :class="{ 'warning': title.length > 80 }">
                  {{ title.length }}/100
                </span>
              </div>
            </div>
          </div>

            <div class="form-group">
              <label class="form-label">
                <i class="el-icon-document"></i>
                <span>文章内容</span>
                <EmojiPicker @select="insertEmoji" />
              </label>
              <div class="editor-wrapper">
                <mavon-editor 
                  ref="md"
                  v-model="content"
                  :boxShadow="false"
                  :autofocus="true"
                  placeholder="请输入文章内容，支持 Markdown 语法..."
                  :toolbars="toolbars"
                  :toolbarsFlag="true"
                  @imgAdd="$imgAdd"
                  class="markdown-editor"
                />
              </div>
            </div>
        </div>

        <div class="publish-actions">
          <div class="action-left">
            <el-tag v-if="categoryId" type="success" size="small" effect="plain">
              已选择分类
            </el-tag>
            <el-tag v-else type="info" size="small" effect="plain">
              请选择分类
            </el-tag>
            <span class="preview-tip">
              <i class="el-icon-info"></i>
              支持 Markdown 语法
            </span>
          </div>
          <div class="action-right">
            <el-button @click="handleCancel" :disabled="submitting">
              取消
            </el-button>
            <el-button 
              type="primary" 
              @click="submit" 
              :loading="submitting"
              :disabled="!canSubmit">
              {{ submitting ? '发布中...' : '发布文章' }}
            </el-button>
          </div>
        </div>
      </div>

      <div class="publish-sidebar">
        <div class="sidebar-card">
          <div class="card-header">
            <i class="el-icon-document-copy"></i>
            <span>发帖规范</span>
          </div>
          <ul class="rules-list">
            <li class="rule-item">
              <i class="el-icon-chat-dot-round"></i>
              <span>文明用语，尊重他人</span>
            </li>
            <li class="rule-item">
              <i class="el-icon-location-outline"></i>
              <span>主题明确，内容准确</span>
            </li>
            <li class="rule-item">
              <i class="el-icon-lock"></i>
              <span>不发布侵权、违法内容</span>
            </li>
            <li class="rule-item">
              <i class="el-icon-search"></i>
              <span>避免重复发帖</span>
            </li>
            <li class="rule-item">
              <i class="el-icon-bank-card"></i>
              <span>禁止发布广告</span>
            </li>
            <li class="rule-item">
              <i class="el-icon-tickets"></i>
              <span>保持格式整齐</span>
            </li>
          </ul>
        </div>

        <div class="sidebar-card tips-card">
          <div class="card-header">
            <i class="el-icon-lightbulb"></i>
            <span>写作建议</span>
          </div>
          <ul class="tips-list">
            <li>• 使用清晰的标题概括文章内容</li>
            <li>• 合理分段，提高可读性</li>
            <li>• 添加代码块时注明编程语言</li>
            <li>• 引用他人内容请注明出处</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmojiPicker from '../components/EmojiPicker.vue'
export default {
  name: "Publish",
  components: {
    EmojiPicker
  },
  data() {
    return {
      title: "",
      content: "",
      showCommunityList: false,
      selectCommunity: [],
      communityList: [],
      categoryId: "",
      submitting: false,
      toolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: true,
        readmodel: true,
        help: true,
        preview: true
      }
    };
  },
  computed: {
    canSubmit() {
      return this.title.trim() && this.content.trim() && this.categoryId;
    }
  },
  methods: {
    insertEmoji(emoji) {
      this.content += emoji
    },
    // 处理图片上传
    $imgAdd(pos, $file) {
      const formData = new FormData();
      formData.append('file', $file);
      formData.append('path', 'article/' + new Date().getFullYear() + '/' + (new Date().getMonth() + 1));
      
      this.$axios({
        method: 'post',
        url: '/file/upload',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        if (response.code === '200' || response.code === 200) {
          // 上传成功，替换图片链接
          const imageUrl = response.data;
          this.$refs.md.$img2Url(pos, imageUrl);
          this.$message.success('图片上传成功');
        } else {
          this.$message.error(response.msg || '图片上传失败');
          // 上传失败，删除图片
          this.$refs.md.$imgDel(pos);
        }
      }).catch(error => {
        console.error('图片上传失败:', error);
        this.$message.error('图片上传失败');
        // 上传失败，删除图片
        this.$refs.md.$imgDel(pos);
      });
    },
    submit() {
      if (!this.canSubmit) {
        if (!this.title.trim()) {
          this.$message.warning('请输入文章标题');
          return;
        }
        if (!this.content.trim()) {
          this.$message.warning('请输入文章内容');
          return;
        }
        if (!this.categoryId) {
          this.$message.warning('请选择文章分类');
          return;
        }
      }

      this.submitting = true;
      this.$axios({
        method: "post",
        url: "/doc/addDoc",
        data: {
          title: this.title.trim(),
          content: this.content,
          categoryId: this.categoryId
        }
      })
          .then(response => {
            this.submitting = false;
            if (response.code == 200) {
              this.$message.success('发表成功');
              setTimeout(() => {
                this.$router.push({ path: "/" });
              }, 500);
            } else {
              this.$message.error(response.msg || '发表失败');
            }
          })
          .catch(error => {
            this.submitting = false;
            console.log(error);
            this.$message.error('发表失败，请稍后重试');
          });
    },
    handleChange(value) {
      this.categoryId = value[value.length - 1];
    },
    getCommunityList() {
      this.$axios({
        method: "post",
        data: {},
        url: "/category/categoryTree"
      })
          .then(response => {
            if (response.code == 200 && response.data) {
              this.communityList = this.transformData(response.data.children || response.data);
            } else {
              this.$message.error(response.msg || '获取分类失败');
            }
          })
          .catch(error => {
            console.log(error);
            this.$message.error('获取分类失败');
          });
    },
    transformData(data) {
      if (!data) return [];
      return data.map(item => {
        const transformedItem = {
          value: item.id,
          label: item.categoryName,
          children: item.children && item.children.length > 0
              ? this.transformData(item.children)
              : undefined
        };
        return transformedItem;
      });
    },
    handleCancel() {
      this.$confirm('确定要取消发布吗？未保存的内容将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back();
      }).catch(() => {});
    }
  },
  mounted() {
    this.getCommunityList();
  }
};
</script>
<style lang="less" scoped>
.publish-container {
  min-height: calc(100vh - 48px);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px;
  margin-top: 48px;

  .publish-header {
    text-align: center;
    margin-bottom: 32px;
    color: #fff;

    .publish-title {
      font-size: 32px;
      font-weight: 600;
      margin: 0 0 8px 0;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .publish-subtitle {
      font-size: 14px;
      opacity: 0.9;
      margin: 0;
    }
  }

  .publish-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 24px;

    .publish-main {
      flex: 1;
      min-width: 0;
      background: #fff;
      border-radius: 12px;
      padding: 24px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

      .form-section {
        .form-row {
          display: flex;
          gap: 16px;
          margin-bottom: 24px;

          .form-group:first-child {
            flex: 0 0 200px;
            max-width: 200px;
          }

          .form-group:nth-child(2) {
            flex: 1;
            margin-bottom: 0;
          }

          .form-group {
            .form-label {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 14px;
              font-weight: 600;
              color: #333;
              margin-bottom: 12px;

              i {
                color: #667eea;
                font-size: 16px;
              }
            }

            .category-cascader {
              width: 100%;
            }

            .title-input-wrapper {
              position: relative;

              .post-title-input {
                width: 95%;
                padding: 12px 16px;
                border: 2px solid #e8e8e8;
                border-radius: 8px;
                font-size: 16px;
                font-weight: 500;
                transition: all 0.3s;
                outline: none;

                &:focus {
                  border-color: #667eea;
                  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
                }

                &::placeholder {
                  color: #999;
                }
              }

              .char-count {
                position: absolute;
                right: 12px;
                bottom: 8px;
                font-size: 12px;
                color: #999;
                transition: color 0.3s;

                &.warning {
                  color: #f56c6c;
                }
              }
            }
          }
        }

        .form-group {
          margin-bottom: 24px;

          .editor-wrapper {
            position: relative;
            border: 2px solid #e8e8e8;
            border-radius: 8px;
            overflow: hidden;
            transition: border-color 0.3s;

            .editor-toolbar-extra {
              position: absolute;
              top: -40px;
              right: 0;
              z-index: 10;
            }

            &:focus-within {
              border-color: #667eea;
            }

            .markdown-editor {
              min-height: 500px;

              // 图片上传样式
              /deep/ .v-note-btn-upload {
                position: relative;
                overflow: hidden;

                input[type="file"] {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  opacity: 0;
                  cursor: pointer;
                }
              }

              // 图片预览样式
              /deep/ .v-show-content {
                img {
                  max-width: 100%;
                  cursor: pointer;
                  transition: transform 0.3s;

                  &:hover {
                    transform: scale(1.02);
                  }
                }
              }

              /deep/ .v-note-op {
                background-color: #f5f5f5;
                border-bottom-color: #e8e8e8;
              }

              /deep/ .v-note-panel {
                background-color: #fff !important;

                .v-note-edit {
                  background-color: #fff !important;

                  .v-show-content,
                  .v-note-div {
                    background-color: #fff !important;
                    color: #333;

                    textarea {
                      background-color: #fff !important;
                      color: #333;
                    }
                  }
                }

                .v-note-preview {
                  background-color: #fff !important;
                  color: #333;
                }
              }

              /deep/ .auto-textarea-wrapper,
              /deep/ .content-input {
                background-color: #fff !important;

                textarea {
                  background-color: #fff !important;
                  color: #333;
                }
              }
            }
          }
        }
      }

      .publish-actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        border-top: 1px solid #e8e8e8;
        margin-top: 24px;

        .action-left {
          display: flex;
          align-items: center;
          gap: 12px;

          .preview-tip {
            font-size: 12px;
            color: #999;
            display: flex;
            align-items: center;
            gap: 4px;
          }
        }

        .action-right {
          display: flex;
          gap: 12px;

          .el-button {
            min-width: 100px;
            height: 40px;
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
    }

    .publish-sidebar {
      width: 300px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .sidebar-card {
        background: #fff;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

        .card-header {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 16px;
          font-weight: 600;
          color: #333;
          padding-bottom: 14px;
          border-bottom: 2px solid #f0f0f0;

          i {
            color: #667eea;
            font-size: 20px;
          }
        }

        .rules-list {
          list-style: none;
          padding: 0;
          margin: 16px 0 0 0;

          .rule-item {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            padding: 10px 0;
            font-size: 13px;
            color: #666;
            line-height: 1.6;
            border-bottom: 1px solid #f5f5f5;

            &:last-child {
              border-bottom: none;
            }

            i {
              color: #667eea;
              font-size: 16px;
              margin-top: 2px;
              flex-shrink: 0;
            }
          }
        }

        .tips-list {
          list-style: none;
          padding: 0;
          margin: 16px 0 0 0;

          li {
            padding: 8px 0;
            font-size: 13px;
            color: #666;
            line-height: 1.6;
            border-bottom: 1px solid #f5f5f5;

            &:last-child {
              border-bottom: none;
            }
          }
        }

        &.tips-card {
          .card-header i {
            color: #f7b500;
          }
        }
      }
    }
  }
}

@media (max-width: 968px) {
  .publish-content {
    flex-direction: column;

    .publish-sidebar {
      width: 100%;
    }
  }
}
</style>